package one.healthium.profile.ui.food_history.models

import kotlinx.serialization.Serializable
import one.healthium.domain.common.FoodUnit
import one.healthium.domain.user.models.FoodItemModel
import one.healthium.domain.user.models.FoodLogModel
import androidx.compose.runtime.Immutable
import kotlin.time.Instant

@Immutable
data class FoodLogUiModel(
    val date: Instant,
    val food: List<FoodItemUiModel>,
) {
    companion object {
        fun fromModel(model: FoodLogModel): FoodLogUiModel {
            return FoodLogUiModel(
                date = model.date,
                food = model.food.map { foodItem ->
                    FoodItemUiModel.fromModel(foodItem, model.id)
                }
            )
        }
    }
}

@Serializable
@Immutable
data class FoodItemUiModel(
    val id: String?,
    val date: Instant,
    val dayId: String?,
    val amount: Float,
    val isLiquid: Boolean,
    val name: String,
    val calories: Float,
    val fat: Float,
    val carbohydrates: Float,
    val fiber: Float,
    val protein: Float,
    val tablespoon: Float?,
    val cups: Float?,
    val pieces: Float?,
    val portion: Float?,
    val unit: FoodUnit?,
) {
    companion object {
        fun fromModel(model: FoodItemModel, dayId: String?): FoodItemUiModel {
            return FoodItemUiModel(
                id = model.id,
                dayId = dayId,
                date = model.date,
                amount = model.amount,
                isLiquid = model.isLiquid,
                name = model.name,
                calories = model.calories,
                fat = model.fat,
                carbohydrates = model.carbohydrates,
                protein = model.protein,
                fiber = model.fiber,
                tablespoon = model.tablespoon,
                cups = model.cups,
                pieces = model.pieces,
                portion = model.portion,
                unit = model.unit,
            )
        }
    }
}
